import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["calculationType", "quantitySection", "unit"]

  connect() {
    this.update()
  }

  update() {
    const quantityBased = this.calculationTypeTargets.find((input) => input.checked)?.value === "quantity_based"

    this.quantitySectionTarget.classList.toggle("hidden", !quantityBased)
    this.quantitySectionTarget.querySelectorAll("input, select, button").forEach((element) => {
      element.disabled = !quantityBased
    })
    this.unitTarget.required = quantityBased
  }

  currencyChanged(event) {
    const row = event.currentTarget.closest("[data-nested-form-row]")
    const prefix = row?.querySelector(".field-prefix")
    if (prefix) prefix.textContent = event.currentTarget.value.trim().toUpperCase()
  }
}
